// extracted by mini-css-extract-plugin
export default {"vocabularyArea":"vocabulary-area_vocabularyArea__RbTnZ","transArea":"vocabulary-area_transArea__1wNWu"};